import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

import { Slide, ToastContainer } from "react-toastify";
import Header from './components/Header';
import Footer from './components/Footer';
import LandingPage from './components/LandingPage';
import Signup from './pages/signup';
import Login from './pages/login';
import AdminLogin from './pages/AdminP/admin-login';
import Admindashboard from './pages/AdminP/admin-dashboard';
import Survey from './pages/survey';
import Search from './pages/search';
import PreSignup from './pages/pre-signup';
import Contactus from './pages/contactUs';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import PeopleProfile from './pages/people-profile-page';
import CompanyProfile from './pages/company-profile-page';
import Inpuserlisting from './pages/inp-user-listing';
import Company from './pages/company';
import AddCompany from './pages/add-company';
import About from './pages/about'; 
import ProtectedRoute from './components/UserC/ProtectedRoute';
import AdminProtectedRoute from './components/AdminC/AdminProtectedRoute';
import AdminProvider from './context/AdminContext';
import AdminDashboardContent from './pages/AdminP/AdminDashboardContent';
import AdminCompany from './pages/AdminP/AdminCompanies';
import AdminInpPanel from './pages/AdminP/AdminInpPanel';
import AdminWallet from './pages/AdminP/AdminWallet';
import AdminSurveyManagement from './pages/AdminP/AdminSurveyManagement';
import AdminAddCompany from './pages/AdminP/AdminAddCompany';
import MyProfile from './pages/MyProfile';
import People from './pages/People';
import CustomCursor from './reactbits/Ribbons';
import ScrollToTop from './components/ScrollToTop';
import Dashboard from './pages/dashboard';


function AppContent() {
  const location = useLocation();

  // Hide Header and Footer on /AdminLogin, /Admindashboard, and /Company (case-insensitive)
  const hideLayout = ['/adminlogin', '/admindashboard', '/admindashboard/companies','/admindashboard/companies/add-new-company', '/admindashboard/inp-panel','/admindashboard/wallet','/admindashboard/survey-management'].includes(location.pathname.toLowerCase());

  useEffect(() => {
      AOS.init({ duration: 1000, once: true });
  }, []);


  return (
    <>

    <ToastContainer
      position="top-center"
      autoClose={1500}
      stacked
      hideProgressBar
      newestOnTop
      closeOnClick={false}
      rtl={false}
      pauseOnFocusLoss
      draggable={false}
      pauseOnHover
      theme="light"
      transition={Slide}
      toastStyle={{ fontSize: "14px", fontWeight: 500, color: "#000", padding: "4px 16px" }}
    />
    {!hideLayout && <Header />}

    <AdminProvider>

      <CustomCursor />

      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/PreSignup" element={<PreSignup />} />
        <Route path="/Contactus" element={<Contactus />} />
        <Route path="/TermsAndConditions" element={<TermsAndConditions />} />
        <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/About" element={<About />} />        
        <Route path="/myprofile" element={<MyProfile />} />

        <Route
          path="/Dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
             </ProtectedRoute>
          }
        />

        <Route
          path="/Survey"
          element={
            <ProtectedRoute>
              <Survey />
             </ProtectedRoute>
          }
        />

        <Route path="/search" element={
            <ProtectedRoute>
              <Search />
            </ProtectedRoute>
          }
        />
        <Route path="/PeopleProfile/:member_id" element={
            <ProtectedRoute>
              <PeopleProfile />
            </ProtectedRoute>
          }
        />
        <Route path="/CompanyProfile/:company_id" element={
            <ProtectedRoute>
              <CompanyProfile />
            </ProtectedRoute>
          }
        />        
        <Route path="/Inpuserlisting" element={
            <ProtectedRoute>
              <Inpuserlisting />
            </ProtectedRoute>
          }
        />
        <Route path="/Company" element={
            <ProtectedRoute>
              <Company />
            </ProtectedRoute>
          }
        />
        <Route path="/AddCompany" element={
            <ProtectedRoute>
              <AddCompany />
            </ProtectedRoute>
          }
        />
        {/* Admin Routes  */}
        <Route path="/adminLogin" element={<AdminLogin />} />
        <Route path="/admindashboard" element={<AdminProtectedRoute> <Admindashboard /></AdminProtectedRoute>}>
          <Route index element={<AdminDashboardContent />} />  
          <Route path="companies" element={<AdminCompany />} />
          <Route path="inp-panel" element={<AdminInpPanel />} />
          <Route path="wallet" element={<AdminWallet />} />
          <Route path="survey-management" element={<AdminSurveyManagement />} />
          <Route path="companies/add-new-company" element={<AdminAddCompany />} />
        </Route>
      </Routes>
    </AdminProvider>
      
    {!hideLayout && <Footer />}
    </>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppContent />
    </Router>
  );
}

export default App;